/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

//Controllers
angular.module('moebiusProadapt', []);
require('./controllers/home');
require('./controllers/dashboard');
require('./controllers/navbar');
require('./controllers/admin/adminIndex');
require('./controllers/admin/adminAddUser');
require('./controllers/admin/adminAddCentre');
require('./controllers/etude-def/etudeDefIndex');
require('./controllers/etude/etudeIndex');
require('./controllers/etude/etudeAddParticipant');
require('./controllers/etude/etudeDetailParticipant');
require('./controllers/etude/participantTraitement');
require('./controllers/etude/participantPriseencharge');
require('./controllers/etude/participantEicomplication');
require('./controllers/etude/participantEvaluationMaladie');
require('./controllers/etude/participantPecTherapeutique');
require('./controllers/etude/participantParcoursSoin');
require('./controllers/etude/participantSS');
require('./controllers/etude/qvShowHistory');
require('./controllers/etude/qvRaisonNonRempli');
require('./controllers/etude/onglet/filteredOnglet');
require('./controllers/settings/settings');
require('./controllers/lists/lists');
require('./controllers/utilisateurs/utilisateursIndex');
require('./controllers/utilisateurs/utilisateursAddUser');
require('./controllers/logs/logsIndex');

require('./services/mbs-resolver');
require('./services/mbs-eti-service');
require('./services/mbs-participant-service');
require('./services/mbs-user-service');
require('./services/mbs-lookup');


require('./directives/form');
require('./directives/actived');
require('./directives/timeline');
// require('./directives/angular-yc-navbar-affix');





angular.module('Application', [
//    'ngFx',
    'ngRoute',
    'ngSanitize',
    'ngAnimate',

    'angular-growl',
    'ui.bootstrap',
    'ui.slider',
    'angularMoment',


//
     'ui.select',
//
     'ui.sortable',
//
//     'agGrid',
//
    'ajoslin.promise-tracker',
//
//     'angularFileUpload',
//

    'moebiusProadapt',
    // 'ActivedDirectives',
    // 'yc.navbar.affix',
    'duScroll'

])
    .config(['$routeProvider', '$httpProvider', 'growlProvider', '$provide', 'uibDatepickerConfig', function ($routeProvider, $httpProvider, growlProvider, $provide, uibDatepickerConfig) {


        $routeProvider
            .when('/dashboard', {
                templateUrl: 'assets/templates/dashboard/index.html',
                controller: 'ctrlDashboard',
                resolve: {
                    dashboardResolver: function (mbsResolver) {
                        return mbsResolver.url('etude-instance/dashboard');
                    },
                }

            })
            .when('/admin', {
                templateUrl: 'assets/templates/admin/index.html',
                controller: 'ctrlAdminIndex',
                resolve: {
                    adminResolver: function ($http) {
                        return $http.get('admin').then(function (r) {
                            return r.data;
                        });
                    },
                }
            })
            .when('/utilisateurs', {
                templateUrl: 'assets/templates/utilisateurs/index.html',
                controller: 'ctrlUtilisateursIndex',
                resolve: {
                    utilisateursResolver: function ($http) {
                        return $http.get('utilisateurs').then(function (r) {
                            return r.data;
                        });
                    },
                }
            })
            .when('/logs', {
                templateUrl: 'assets/templates/logs/index.html',
                controller: 'ctrlLogsIndex',
                resolve: {
                    logsResolver: function ($http) {
                        return $http.get('logs').then(function (r) {
                            return r.data;
                        });
                    },
                }
            })
            .when('/etude-def/:id', {
                templateUrl: 'assets/templates/etude-def/index.html',
                controller: 'ctrlEtudeDefIndex',
                resolve: {
                    etude_def_builder_configuration: function (mbsResolver, $route, $http, mbsEtiService) {
                        var etude_def_key        = $route.current.params.id;
                        return $http.get('etude-def/builder-etude-def/'+etude_def_key)
                            .then(function(resp){

                                console.log('eti configuration queried on server');
                                mbsEtiService.storeData(resp.data);

                                return mbsEtiService.getConfigurationForEti(0);

                            });
                    },
                    etiAllDynamicDropdown: function(mbsResolver, $http, $route, mbsLookupService) {
                        var etude_def_key        = $route.current.params.id;
                        return $http.get('etude-def/builder-etude-def-dynamic-dropdown/'+etude_def_key)
                                .then(function(resp){
                                mbsLookupService.storeData(resp.data);

                                return mbsLookupService.getLookupListForEti(0);
                            });
                    },
                    fakeDetailParticipantResolver: function ($route, $http, mbsParticipantService) {
                        var etude_def_key        = $route.current.params.id;
                        return $http.get('etude-def/builder-etude-def-participant/' + etude_def_key ).then(function (r) {
                            mbsParticipantService.initWithParticipant(r.data.participant);
                            return mbsParticipantService.getCurrentParticipant();
                        });
                    },
                    allQuestionnaireTemplate: function($http) {
                        return $http.get('questionnaire-template').then(function(r){
                            return r.data.data
                        });
                    },
                    allQuestionMereTemplate: function($http) {
                        return $http.get('question-mere-template').then(function(r){
                            return r.data.data
                        });
                    }
                }
            })
            .when('/etude/:id', {
                templateUrl: 'assets/templates/etude/index.html',
                controller: 'ctrlEtudeIndex',
                resolve: {
                    eti_configuration: function (mbsResolver) {
                        return mbsResolver.etiConfiguration('etude-instance/configuration', {id: null})
                    },
                    participantResolver: function (mbsResolver) {
                        return mbsResolver.url('etude-instance/liste-participants', {id: null});
                    },
                    etiAllDynamicDropdown: function(mbsResolver) {
                        return mbsResolver.etiAllDynamicDropdown('etude-instance/all-dynamic-dropdown' , {id: null})
                    }
                }
            })
            .when('/etude/:id/participant/:id_participant/:visite?', {
                templateUrl: 'assets/templates/etude/detail-participant-wrapper.html',
                controller: 'ctrlEtudeDetailParticipant',
                resolve: {
                    eti_configuration: function (mbsResolver) {
                        return mbsResolver.etiConfiguration('etude-instance/configuration', {id: null})
                    },
                    detailParticipantResolver: function ($route, $http, mbsParticipantService) {
                        var id_etude        = $route.current.params.id;
                        var id_participant  = $route.current.params.id_participant;
                        var visite_key      = $route.current.params.visite;
                        return $http.get('etude-instance/detail/etude/' + id_etude + '/visite/' + visite_key +  '/participant/' + id_participant).then(function (r) {
                            mbsParticipantService.initWithParticipant(r.data.participant);
                            return mbsParticipantService.getCurrentParticipant();
                        });
                    },
                    visiteKey: function ($route) {
                        var visite_key  = $route.current.params.visite;
                        return visite_key;
                    },
                    etiAllDynamicDropdown: function(mbsResolver) {

                        return mbsResolver.etiAllDynamicDropdown('etude-instance/all-dynamic-dropdown', {id: null})
                    }
                }
            })
            .when('/settings/:resource/:zone?/:zone_key?', {
                template : '<div ng-include="getTemplateListUrl()"></div>',
                controller: 'ctrlSettings',
                resolve:{
                    list: function ($http, $route, $location) {
                            var payloadSearch = $location.search();
                            // -- object to URL param
                            var urlParam = angular.element.param(payloadSearch);
                            var resource = $route.current.params.resource;
                            if(resource === "commentaires" && typeof $route.current.params.zone !== 'undefined' && $route.current.params.zone.length > 0) {
                                resource += '?zone=' + $route.current.params.zone ;
                                if(typeof $route.current.params.zone_key !== 'undefined' && $route.current.params.zone_key.length > 0) {
                                    resource += '&zone_key=' + $route.current.params.zone_key ;
                                }
                                if(urlParam.length > 0) {
                                    resource += '&' + urlParam;
                                }
                            } else if (urlParam.length > 0) {
                                resource += '?' + urlParam;
                            }
                            return $http.get(resource).then(function(r){
                                return r.data
                            });
                    },
                    resource: function ($q, $route) {
                        var deferred = $q.defer();
                        deferred.resolve($route.current.params.resource);
                        return deferred.promise;
                    },
                    mainFk: function ($http, $route, $location) {
                        return $location.search();
                    }
                }
            })
            .otherwise({
                redirectTo: '/dashboard'
            })
        ;

        //DATEPICKER CONFIGURATION
        uibDatepickerConfig.dateFormat="yyyy-MM-dd";

        // -- growl interceptor to handle thrown exception
        $httpProvider.interceptors.unshift(function ($q, growl, $window) {
            return {
                'request': function request(config) {
                    // --config.tracker = $rootScope.tracker;
                    return config;
                }, // -- in rejection promise
                'responseError': function responseError(rejection) {
                    if (rejection.status === 401) {
                        $window.location = 'login';
                    } else if (rejection.data && rejection.data.message) {
                        // gonna growl the message content
                        growl.error(rejection.data.message, {
                            ttl: 5000
                        });
                    } else {
                        growl.error('HTTP_NO_RESPONSE', { ttl: 5000 });
                    }
                    return $q.reject(rejection);
                }
            };
        });

    }])
    .run(['$rootScope', '$location', '$http', '$timeout', '$anchorScroll', 'amMoment', 'mbsEtiService', 'mbsUser', 'mbsLookupService', 'mbsParticipantService', '$uibModal', 'growl', function ($rootScope, $location, $http, $timeout, $anchorScroll, amMoment, mbsEtiService, mbsUser, mbsLookupService, mbsParticipantService, $uibModal, growl) {
        $rootScope.globalParams = {
            APP_VERSION: APP_VERSION,
            showDebug: false,
            moebiusMode: true,
            isDirectSaveMode: true,
            isRemoteCallbackMode: true
        };
        $rootScope.toggleDebug      = function() {

            $timeout(function() {
                $rootScope.globalParams.showDebug = !$rootScope.globalParams.showDebug;
            });
        };
        $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels

        $rootScope.mbsUser          = mbsUser;
        $rootScope.openModalChangePwdUser = function () {

            var scopeModal = $rootScope.$new();

            //Create modal instance
            $uibModal.open({
                templateUrl: 'assets/templates/settings/modals/modal-update-user.html',
                controller: 'ctrlAdminAddUser',
                windowClass: 'md-dialog',
                scope: scopeModal,
                backdrop: 'static',
                resolve: {
                    user: angular.copy($rootScope.mbsUser)
                }
            });
        };

        $rootScope.savePass = function(user) {
            if(typeof user.password !== undefined) {
                var formData = {
                    "password": user.password
                } ;
                $http.post('user/changePassword', formData).then(function (response) {
                    // -- puis on refresh
                    growl.warning("Mot de passe changé", { ttl: 5000 });
                }).catch(function (e) {
                    growl.error("Une erreur est survenue durant le changement du mot de passe", { ttl: 5000 });
                    console.log(e);
                });
            }
        };
// $rootScope.mbsEtiService    = mbsEtiService;

// $rootScope.mbsLookupService = mbsLookupService;

        $http.get('constants').then(function (r) {
            $rootScope.constants = r.data;
            // console.log($rootScope.constants);
            $rootScope.mbsUser.init(r.data.user, r.data.centresById);
        });

        mbsEtiService.init();

        mbsParticipantService.init();
    }])
    .value('duScrollGreedy', true)
    .value('duScrollDuration', 10)
    ;

//Filter: Underscore
angular.
module('moebiusProadapt')
    .filter('_', function () {
    //UNDERSCORE shortcut filter
    return function (input, func) {
        var args = _.toArray(arguments) //convert Arguments to Array
        args.splice(1, 1); //removes function name from arguments list
//            console.log('FUNC', func, 'INPUT', input, 'ARGS', args);
        if (_[func]) {
            return _[func].apply(_, args);
        }
        else {
            return input;
        }
    };
}).filter('orderObjectBy', function () {
    return function (items, field, reverse) {
        var filtered = [];
        angular.forEach(items, function (item) {
            filtered.push(item);
        });
        filtered.sort(function (a, b) {
            return (a[field] > b[field] ? 1 : -1);
        });
        if (reverse) filtered.reverse();
        return filtered;
    };
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js